// extracted by mini-css-extract-plugin
export default {"selectBox":"select_selectBox__TPyUc","solid":"select_solid__XuW0u","outline":"select_outline__lvzTD","arrow":"select_arrow__fNJb5"};